import { t } from "i18next";
import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { ArrowRight2 } from "iconsax-react";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import DBSpinner from "../../component/global/DBSpinner";
import { useRequest } from "../../hooks/helperData/useRequest";
import { surveyDetailUrl } from "../../helperData/ApiAddress";
import { surveyStatusLabel, isPhoneSurvey } from "./constants";
import CampaignsPanel from "./CampaignsPanel";
import ResultsPanel from "./ResultsPanel";
import PhoneCallCenter from "./PhoneCallCenter";
import SurveyGuideModal from "./SurveyGuideModal";

export default function SurveyDetail({
    surveyId,
    onBack,
    initialTab = "results",
    initialPhoneCampaignId = null,
    personal = false,
    embedded = false,
}) {
    const [survey, setSurvey] = useState(null);
    const [selectedTab, setSelectedTab] = useState(initialTab);
    const [phoneCampaignId, setPhoneCampaignId] = useState(
        initialPhoneCampaignId
    );
    const [guideShow, setGuideShow] = useState(false);
    const [getSurvey, getSurveyLoading] = useRequest(
        surveyDetailUrl(surveyId),
        "GET"
    );

    useEffect(() => {
        getSurvey().then(setSurvey).catch(() => setSurvey(null));
    }, [surveyId]);

    return (
        <div
            className={[
                "surveys-page",
                embedded ? "is-embedded" : "main_panel_box",
                personal ? "is-personal" : "",
            ]
                .filter(Boolean)
                .join(" ")}
        >
            {!embedded && (
                <MainPanelHeader
                    panelType={t("Corpration.Panel.label")}
                    panelName={t("survey.title")}
                />
            )}
            <div className={embedded ? undefined : "main_panel_content"}>
                <div className={embedded ? undefined : "right_content main_box"}>
                    <button
                        type="button"
                        className="survey-back-button"
                        onClick={onBack}
                    >
                        <ArrowRight2 size={18} aria-hidden="true" />
                        <span>{t("survey.list.title")}</span>
                    </button>
                    {getSurveyLoading || !survey ? (
                        <DBSpinner tip={t("loading")} />
                    ) : (
                        <div className="tab-section surveys-tab-section">
                            <div className="survey-detail-header">
                                <h2>{survey.title}</h2>
                                <span
                                    className={`survey-status status-${survey.status}`}
                                >
                                    {surveyStatusLabel(survey.status)}
                                </span>
                                <button
                                    type="button"
                                    className="survey-help-button"
                                    title={t("survey.guide.title")}
                                    aria-label={t("survey.guide.title")}
                                    onClick={() => setGuideShow(true)}
                                >
                                    ?
                                </button>
                            </div>
                            <Tabs
                                activeKey={selectedTab}
                                transition={false}
                                mountOnEnter
                                unmountOnExit
                                className="panel_tab"
                                onSelect={(key) =>
                                    setSelectedTab(key || "campaigns")
                                }
                            >
                                <Tab
                                    eventKey="campaigns"
                                    className="panel_tab_item"
                                    title={t("survey.detail.campaigns")}
                                >
                                    <div className="surveys-content">
                                        <CampaignsPanel
                                            survey={survey}
                                            linkOnly={personal}
                                            onOpenCallCenter={(campaign) => {
                                                setPhoneCampaignId(campaign.id);
                                                setSelectedTab("phone");
                                            }}
                                        />
                                    </div>
                                </Tab>
                                {isPhoneSurvey(survey) && (
                                <Tab
                                    eventKey="phone"
                                    className="panel_tab_item"
                                    title={t("survey.detail.phone")}
                                >
                                    <div className="surveys-content">
                                        <PhoneCallCenter
                                            survey={survey}
                                            initialCampaignId={phoneCampaignId}
                                        />
                                    </div>
                                </Tab>
                                )}
                                <Tab
                                    eventKey="results"
                                    className="panel_tab_item"
                                    title={t("survey.detail.results")}
                                >
                                    <div className="surveys-content">
                                        <ResultsPanel survey={survey} />
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    )}
                </div>
            </div>
            <SurveyGuideModal
                show={guideShow}
                onHide={() => setGuideShow(false)}
            />
        </div>
    );
}
